import React from 'react';
import './App.css';


const TGCert=() => {
  return (
    <div className="container">
      <h2>CERT.tg (TG) </h2>
      <h3>CERT Togo</h3>
      <p><strong>Listed</strong> since since 09 Jul 2024</p>
      <p className="info-text">This information is provided without guarantee or pro-active maintenance.</p>

      <h3>Fields describing the team</h3>

      <div className="section">
        <h4>Team Details</h4>
        <div className="teams-details">
          <div className="teams-detail">
            <strong>Official Name</strong>
            <p>CERT Togo</p>
          </div>
          <div className="teams-detail">
            <strong>Short Name</strong>
            <p>CERT.tg (TG)</p>
          </div>
          <div className="teams-detail">
            <strong>Country</strong>
            <p> 
            <img src="/assets/images/togo.png" alt="Togo Flag" className="flag-icon" />Togo
            </p>
          </div>
          <div className="teams-detail">
            <strong>Established</strong>
            <p>13 Feb 2019</p>
          </div>
          <div className="teams-detail">
            <strong>Host Organisation</strong>
            <p>Agence Nationale de Cybersecurite (ANCy)</p>
          </div>
        </div>
      </div>

      <h3>Constituency</h3>
      <div className="constituency">
        <div className="constituency-detail">
          <strong>Constituency Type</strong>
          <p>Government, National</p>
        </div>
        <div className="constituency-detail">
          <strong>Country of Constituency</strong>
          <p>Togo</p>
        </div>
        <div className="constituency-detail">
          <strong>ASNs, Domains, IP ranges</strong>
          <p>30982</p>
           <p>37229</p>
            <p>37774</p>

            <p>328152</p>
            <p>328282</p>
            <p>328293</p>
            <p>328463</p>
            <p>328859</p>
            <p>329010</p>
            <p>*.tg</p>
        </div>
        <div className="constituency-detail description">
          <strong>Description of Formal Constituency</strong>
          <p>CERT.tg constituency is composed of:</p>
          <p>- All ministries, administrations and state services</p>
           <p>- Other key players in sensitive sectors </p>
           <p>- All Citizens of the Togolese Republic</p>
        </div>
      </div>

      <h3>Team Contact Information</h3>
      <div className="contact-infos">
        <div className="contact-details">
          <strong>Main Number</strong>
          <p>+228 22 53 59 80</p>
          
        </div>
        <div className="contact-details">
          <strong>Emergency Number</strong>
          <p>+228 70 54 93 25</p>
        </div>
        <div className="contact-details">
          <strong>Fax Number</strong>
          <p>-</p>
        </div>
        <div className="contact-details">
          <strong>Email</strong>
          <p>contact@cert.tg</p>
        </div>
        <div className="contact-details">
          <strong>Other Contact</strong>
          <p>-</p>
          
        </div>
        <div className="contact-details">
          <strong>Postal Address</strong>
          <p>Ministere de la Economie</p>
        <p>Numerique et de la</p>
         <p>Transformation Digitale - Rue Abdoulaye Fadiga </p>
         <p>07 - BP 13215 Lome</p>
        </div>
        <div className="contact-details">
          <strong>Automated Reporting E-Mail</strong>
          <p>incidents@cert.tg</p>
        </div>
        <div className="contact-details">
          <strong>Autom. Rep. Supported Formats</strong>
          <p>-</p>
        </div>
        <div className="contact-details">
          <strong>Business Hours</strong>
          <p>24/7</p>
          
        </div>
        <div className="contact-details">
          <strong>Timezone</strong>
          <p>Africa/Maputo</p>
        </div>
      </div>

      <h3>Cryptography</h3>
      <div className="cryptography"> 
</div>
        <div className="section">
        
        <h3>Memberships</h3>
      <div className="memberships-infos"></div>
        <div className="memberships-details">
          <strong>AfricaCERT / OIC-CERT</strong>
          <p>Full Member since </p> 
        </div>
        <div className="memberships-details">
          <strong>FIRST</strong>
          <p>Full Member since 20 May 2022</p> 
        </div>
        <div className="memberships-details">
          <strong>TF-CSIRT / TI	</strong>
          <p>TI Listed since</p> 
        </div>

        <div className="section">
        <h3>Classification</h3>
        <div className="classifications-infos"></div>
        <div className="classification-details">
          <strong>Current State	</strong>
          <p>Listed since 09 July 2024</p>
          </div>

         <div className="classification-details">
          <strong> Entry Date	</strong>
          <p>17 Nov 2022</p>
          </div>

          <div className="section">

        <h3>History</h3>
        <div className="history-infos"></div>
        <div className="historys-details">
          <strong>Date	</strong>
          <p> 09 Jul 2024</p>
          </div>

         <div className="historys-details">
          <strong>Describtion</strong>
          <p>CERT.tg (TG) is now a listed team</p>
          </div> 
        </div>
        </div>
        </div>
      </div>
  );
};

export default  TGCert;
